import { ThemeTypographyObject, VariantObjects } from '../types/theme';
import headings from './components/headings';
import legacyTypographyVariants,
{
  allLegacyTypographyKeyVariants,
  AllLegacyTypographyTypeVariants
} from './typography-legacy';

/** Typography Paragraph Variants */
export type ParagraphTypeVariants = 'paragraph2XL300'
  | 'paragraphXL300'
  | 'paragraphL300'
  | 'paragraphM300'
  | 'paragraphS300'
  | 'paragraph2XL400'
  | 'paragraphXL400'
  | 'paragraphL400'
  | 'paragraphM400'
  | 'paragraphS400';

type ParagraphVariants = VariantObjects<ParagraphTypeVariants, ThemeTypographyObject>;

export const paragraphStyles: ParagraphVariants = {
  paragraph2XL300: {
    color: 'paragraph',
    fontSize: headings['2XL'],
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6
  },
  paragraphXL300: {
    color: 'paragraph',
    fontSize: headings['XL'],
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6
  },
  paragraphL300: {
    color: 'paragraph',
    fontSize: headings['L'],
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6
  },
  paragraphM300: {
    color: 'paragraph',
    fontSize: headings['M'],
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px'
  },
  paragraphS300: {
    color: 'paragraph',
    fontSize: headings['S'],
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px'
  },
  paragraph2XL400: {
    color: 'paragraph',
    fontSize: headings['2XL'],
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6
  },
  paragraphXL400: {
    color: 'paragraph',
    fontSize: headings['XL'],
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6
  },
  paragraphL400: {
    color: 'paragraph',
    fontSize: headings['L'],
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6
  },
  paragraphM400: {
    color: 'paragraph',
    fontSize: headings['M'],
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px'
  },
  paragraphS400: {
    color: 'paragraph',
    fontSize: headings['S'],
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px'
  }
};

export type LabelTypeVariants = 'labelS400'
  | 'labelXS400'
  | 'label2XS400'
  | 'label3XS400';

type LabelVariants = VariantObjects<LabelTypeVariants, ThemeTypographyObject>;

export const labelStyles: LabelVariants = {
  labelS400: {
    color: 'label',
    fontSize: headings['S'],
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: 3
  },
  labelXS400: {
    color: 'label',
    fontSize: headings['XS'],
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px'
  },
  label2XS400: {
    color: 'label',
    fontSize: headings['2XS'],
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px'
  },
  label3XS400: {
    color: 'label',
    fontSize: headings['3XS'],
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px'
  }
};

type InteractiveTypeVariants = 'interactiveL400'
  | 'interactiveM400'
  | 'interactiveS400'
  | 'interactiveXS400'
  | 'interactiveL500'
  | 'interactiveM500'
  | 'interactiveS500'
  | 'interactiveXS500'
  | 'interactiveL700'
  | 'interactiveM700'
  | 'interactiveS700'
  | 'interactiveXS700';

type InteractiveVariants = VariantObjects<InteractiveTypeVariants, ThemeTypographyObject>;

export const interactiveStyles: InteractiveVariants = {
  interactiveL400: {
    color: 'interactive',
    fontSize: headings['L'],
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 4
  },
  interactiveM400: {
    color: 'interactive',
    fontSize: headings['M'],
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '20px'
  },
  interactiveS400: {
    color: 'interactive',
    fontSize: headings['S'],
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 3
  },
  interactiveXS400: {
    color: 'interactive',
    fontSize: headings['XS'],
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '12px'
  },
  interactiveL500: {
    color: 'interactive',
    fontSize: headings['L'],
    fontWeight: 'bold',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 4
  },
  interactiveM500: {
    color: 'interactive',
    fontSize: headings['M'],
    fontWeight: 'bold',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '20px'
  },
  interactiveS500: {
    color: 'interactive',
    fontSize: headings['S'],
    fontWeight: 'bold',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 3
  },
  interactiveXS500: {
    color: 'interactive',
    fontSize: headings['XS'],
    fontWeight: 'bold',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '12px'
  },
  interactiveL700: {
    color: 'interactive',
    fontSize: headings['L'],
    fontWeight: 'bolder',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 4
  },
  interactiveM700: {
    color: 'interactive',
    fontSize: headings['M'],
    fontWeight: 'bolder',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '20px'
  },
  interactiveS700: {
    color: 'interactive',
    fontSize: headings['S'],
    fontWeight: 'bolder',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 3
  },
  interactiveXS700: {
    color: 'interactive',
    fontSize: headings['XS'],
    fontWeight: 'bolder',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '12px'
  }
};

export type TypographyTypeVariants = ParagraphVariants
  | LabelVariants
  | InteractiveVariants;

export type AllTypographyTypeVariants = TypographyTypeVariants
  | AllLegacyTypographyTypeVariants;

const typographyVariants = {
  ...paragraphStyles,
  ...labelStyles,
  ...interactiveStyles
};

const typographyKeyVariants = Object.keys(typographyVariants);

export const allTypographyKeyVariants = [
  ...typographyKeyVariants,
  ...allLegacyTypographyKeyVariants
];

export const allTypographyVariants = {
  ...typographyVariants,
  ...legacyTypographyVariants
};

export default allTypographyVariants;
